module.exports = __webpack_public_path__ + "static/media/gerald_eve.7a3753b2.jpg";